export enum SoStatusEnum {
    OPEN = 'OPEN',
    IN_PROGRESS = 'INPROGRESS',
    PARTIAL_PO = 'PARTIALPO',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED'
}